import(/* webpackMode: "eager" */ "/var/www/kst-frontend-staging/app/faq/page.tsx")